export * from './CustomizationFooterText';
